export default __webpack_public_path__ + "static/media/peripheral.f6674eac.png";